export const generateUnits = (prices) => {
  const data = [];
  const images = ['/images/01.jpg', '/images/02.jpg', '/images/03.jpg', '/images/04.jpg', '/images/05.jpg'];
  
  const unitTypes = {
    1: { name: 'Type A: Three-bedroom ', sqft: '200' },
    4: { name: 'Type D: One-bedroom ', sqft: '89' },
    3: { name: 'Type C: Two-bedroom ', sqft: '129' },
    2: {name: 'Type B: Three-bedroom ', sqft: '181' },
    5: { name: 'Type E: Two-bedroom ', sqft: '129' }
  };

  const unitOrder = [1, 4, 3, 2, 5]; // A, D, C, B, E

  for (let f = 1; f <= 14; f++) {
    for (let i = 0; i < unitOrder.length; i++) {
      const u = unitOrder[i];
      const unitNumber = i + 1;
      const unitType = unitTypes[u];
      data.push({
        id: `U${f < 10 ? '0' + f : f}${unitNumber < 10 ? '0' + unitNumber : unitNumber}`,
        floor: f,
        status: 'available',
        type: unitType.name,
        sqft: unitType.sqft,
        image: images[u - 1],
        pricing: prices[unitType.name]
      });
    }
  }
  return data;
};
